export default "__VITE_ASSET__mKPJLZ0Z__"